import './Layout.css';

import { Outlet } from 'react-router-dom';

import { NavbarWrapper } from '../components/NavbarWrapper';

function Layout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavbarWrapper />
      <main className="w-full">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
